export default __webpack_public_path__ + "static/media/do_clear.a000ab8c.png";